import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { AMPMediaBaseProps } from './AMPMedia.utils';

export const AMPGfycat: React.FunctionComponent<AMPMediaBaseProps> = props => {
  const { additionalStyle, mediaId } = props;
  return (
    <React.Fragment>
      <Helmet>
        <script async={undefined} custom-element="amp-gfycat" src="https://cdn.ampproject.org/v0/amp-gfycat-0.1.js" />
      </Helmet>
      <figure className={css(additionalStyle.style)}>
        {/*
         // @ts-ignore TS2339 */}
        <amp-gfycat width="16" height="9" layout="responsive" data-gfyid={mediaId} />
      </figure>
    </React.Fragment>
  );
};
